import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";

class VenversProviders extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            providers: [],
            attempts: [],
            search:'',
            page: 1,
            attemptsPage: 1,
            total: 0,
            attemptsTotal: 0,
            attemptedProvidersTotal: 0,
            attemptReasonFilter: '',
            attemptReasonFilterCounts: {},
            maxRecords: props.top,
            syncFilter: '',
            activeTab: 'providers',
            syncStatusSummary: {
                exists: 0,
                missing: 0,
            },
            syncingProviderId: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.handleSyncFilter = this.handleSyncFilter.bind(this);
        this.syncProvider = this.syncProvider.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleAttemptReasonFilter = this.handleAttemptReasonFilter.bind(this);
    }

    async getProviders(){
        var url = '/api/venvers/providers/list';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('internal', this.props.internal)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        if(this.state.syncFilter!==''){
            query.append('sync_status', this.state.syncFilter)
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({
            providers: data,
            total: res.data.total,
            syncStatusSummary: {
                exists: res.data.sync_true ?? 0,
                missing: res.data.sync_false ?? 0,
            },
        });
    }

    async getAttempts(){
        const query = new URLSearchParams();
        query.append('page', this.state.attemptsPage);
        query.append('maxRecords', this.state.maxRecords);
        if(this.state.search!=''){
            query.append('search', this.state.search);
        }
        if(this.state.attemptReasonFilter !== ''){
            query.append('reason_filter', this.state.attemptReasonFilter);
        }

        const res = await axios.get(`/api/venvers/providers/attempts?${query.toString()}`);
        this.setState({
            attempts: res.data.data || [],
            attemptsTotal: res.data.total || 0,
            attemptedProvidersTotal: res.data.pending_provider_count || 0,
            attemptReasonFilterCounts: res.data.reason_filter_counts || {},
        });
    }

    handleChange(e){
        this.setState({providers: [], attempts: [], search: e.target.value, page: 1, attemptsPage: 1}, function () {
            this.state.activeTab === 'providers' ? this.getProviders() : this.getAttempts();
        });
    }

    handleSwitch(i, id){
        let items = [...this.state.providers];
        let item = {...items[i]};
        item.active = (item.active)?false:true;
        items[i] = item;

        this.setState({providers: items}, function () {
            this.updateActive(id, items);
        });
    }

    updateCurrentPage(page){
        if (this.state.activeTab === 'attempts') {
            this.setState({attemptsPage: page}, function () {
                this.getAttempts();
            });
            return;
        }

        this.setState({page: page}, function () {
            this.getProviders();
        });
    }

    handleSyncFilter(syncFilter){
        this.setState({syncFilter, page: 1, activeTab: 'providers'}, function () {
            this.getProviders();
        });
    }

    handleTabChange(activeTab){
        this.setState({activeTab}, function () {
            activeTab === 'providers' ? this.getProviders() : this.getAttempts();
        });
    }

    handleAttemptReasonFilter(attemptReasonFilter){
        this.setState({attemptReasonFilter, attemptsPage: 1, activeTab: 'attempts'}, function () {
            this.getAttempts();
        });
    }

    async updateActive(id){
        var url = '/api/providers/update_active/'+id;
        const res = await axios.get(url);
        const data = res.data;
    }

    async syncProvider(provider){
        const providerId = provider.person_id ?? provider.persona?.id;
        const rfc = provider.persona?.rfc;

        if (!rfc) {
            swal.fire({
                text: 'No se encontro RFC para sincronizar este proveedor.',
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
            return;
        }

        this.setState({ syncingProviderId: providerId });

        try {
            const response = await axios.post(`/api/venvers/providers/${encodeURIComponent(rfc)}/sync`);
            swal.fire({
                text: response.data.message || 'Proveedor sincronizado con Venvers.',
                icon: 'success',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
            await this.getProviders();
            await this.getAttempts();
        } catch (error) {
            const message = error.response?.data?.message || 'No se pudo sincronizar el proveedor con Venvers.';
            swal.fire({
                text: message,
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
            await this.getAttempts();
        } finally {
            this.setState({ syncingProviderId: null });
        }
    }

  async componentDidMount() {
    await this.getProviders();
    await this.getAttempts();
  }

  renderProvidersTable(lang) {
    const formatCountryLabel = (countryId) => {
        const normalizedCountryId = Number(countryId);

        if (normalizedCountryId === 1) {
            return 'México';
        }

        if (normalizedCountryId === 2) {
            return 'Colombia';
        }

        if (normalizedCountryId === 3) {
            return 'Brasil';
        }

        return 'Otro';
    };

    return (
        <>
            <table className="table table-borderless table-vertical-center mb-0">
                <tbody>
                {this.state.providers.map((o, i) => {
                    const persona = o.persona || {};
                    const providerId = o.person_id ?? persona.id;
                    const syncStatus = o.sync_status === true || o.sync_status === 1 || o.sync_status === '1';
                    const isSyncing = this.state.syncingProviderId === providerId;
                    const fiscalName = persona.fiscal_name || 'Proveedor sin datos';
                    const identity = persona.identity || 'RFC';
                    const rfc = persona.rfc || 'Sin RFC';
                    const personType = persona.person_type || 'Sin tipo';
                    const regimenId = persona.regimen_id;
                    const regimenName = persona.regimen_descrption;
                    const countryText = persona.country_label || formatCountryLabel(persona.country_id);
                    const templateRegimenCodes = Array.isArray(persona.template_regimen_codes) ? persona.template_regimen_codes : [];
                    const templateRegimenText = templateRegimenCodes.length > 0
                        ? ' (plantilla ' + (persona.template_regimen_dossier_title || 'Sin plantilla') + ' ' + templateRegimenCodes.join(',') + ')'
                        : '';
                    const regimenText = regimenId || regimenName
                        ? 'Regimen fiscal: ' + (regimenId || 'Sin numero') + (regimenName ? ' - ' + regimenName : '')
                        : 'Regimen fiscal: Sin regimen' + templateRegimenText;
                    const ownerEmail = persona.owner_email || 'Sin correo de owner';
                    const venversResult = o.venvers_result || 'Pendiente sincronizacion GDA';
                    const venversResultDate = o.venvers_result_date || o.latest_venvers_log?.created_at || 'Sin fecha de respuesta';

                    return (
                        <tr key={i}>
                        <td className="pl-0 py-5" style={{width: '1%'}}>
                            <div className="symbol symbol-40">
                                <div className={"symbol-label text-white font-weight-bolder bg-primary "  }>
                                {fiscalName.charAt(0).toUpperCase()}
                                </div>
                            </div>
                        </td>
                        <td className="text-left">
                        { this.props.internal == 1 &&
                            <a href={"/providers/"+providerId + "/internal"}>
                                <div className={"text-dark-75 font-weight-bolder mb-1 font-size-lg "  }>
                                     {fiscalName} <span className="text-muted font-weight-normal"> {identity}: {rfc}  </span>
                                </div>
                                <span className="text-muted">{lang.get('messages.tipo')}: {personType} { o.internal_company_identifier ?
                                    <>
                                        | No. {lang.get('messages.interno')}: {o.internal_company_identifier.internal_id }
                                    </>
                                        :
                                        null
                                    }</span>
                                <span className="text-muted d-block">{regimenText}</span>
                                <span className="text-muted d-block">País: {countryText}</span>
                                <span className="text-muted d-block">Email owner: {ownerEmail}</span>
                            </a>
                        }
                        { this.props.internal == 0 &&
                            <a href={"/providers/"+providerId}>
                                <div className={"text-dark-75 font-weight-bolder mb-1 font-size-lg "}>
                                    {fiscalName} <span className="text-muted font-weight-normal">{identity}: {rfc} </span>
                                </div>
                                <span className="text-muted">{lang.get('messages.tipo')}: {personType} { o.internal_company_identifier ?
                                    <>
                                        | No. {lang.get('messages.interno')}: {o.internal_company_identifier.internal_id }
                                    </>
                                        :
                                        null
                                    }</span>
                                <span className="text-muted d-block">{regimenText}</span>
                                <span className="text-muted d-block">País: {countryText}</span>
                                <span className="text-muted d-block">Email owner: {ownerEmail}</span>
                            </a>
                        }
                        </td>
                        <td className="text-left" style={{width: '1%'}}>
                            {syncStatus ? (
                                <span className="badge badge-success">Existe en Venvers</span>
                            ) : (
                                <span className="badge badge-secondary">No existe en Venvers</span>
                            )}
                            <span className="text-muted d-block mt-2" style={{minWidth: '260px', whiteSpace: 'normal'}}>
                                Resultado API: {venversResult}
                            </span>
                            <span className="text-muted d-block mt-1" style={{minWidth: '260px', whiteSpace: 'normal'}}>
                                Fecha respuesta API: {venversResultDate}
                            </span>
                        </td>
                        <td className="text-right">
                            <button
                                type="button"
                                className="btn btn-light-primary btn-sm mr-2"
                                disabled={isSyncing}
                                onClick={() => this.syncProvider(o)}
                                title="Sincronizar con Venvers"
                            >
                                {isSyncing ? 'Sincronizando...' : 'Sincronizar con Venvers'}
                            </button>
                        { this.props.internal == 1 &&
                            <a href={"/providers/"+providerId + "/internal"}>
                            <button className="btn btn-icon btn-light btn-xs">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </button>
                        </a>
                        }
                        { this.props.internal == 0 &&
                            <a href={"/providers/"+providerId}>
                            <button className="btn btn-icon btn-light btn-xs">
                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                            </button>
                        </a>
                        }
                        </td>
                    </tr>
                )})}
                </tbody>
                </table>
            {this.state.total > this.state.maxRecords &&
                <SimplePagination
                updateCurrentPage={this.updateCurrentPage}
                currentPage={this.state.page}
                totalFiles={this.state.total}
                split={this.state.maxRecords} />
            }
        </>
    );
  }

  getExppedifyReasons(attempt) {
      return Array.isArray(attempt.exppedify_reasons) ? attempt.exppedify_reasons : [];
  }

  formatAttemptDate(value) {
      return value ? String(value).replace('T', ' ').replace(/\.\d+Z$/, '').replace(/Z$/, '') : value;
  }

  renderAttemptReasonFilters() {
      const counts = this.state.attemptReasonFilterCounts || {};
      const filters = [
          {value: '', label: 'Todos', countKey: 'all'},
          {value: 'incomplete', label: 'Incompleto', countKey: 'incomplete'},
          {value: 'missing_constancia', label: 'Sin constancia', countKey: 'missing_constancia'},
          {value: 'multiple_dossiers', label: 'Varios expedientes', countKey: 'multiple_dossiers'},
          {value: 'api_error', label: 'Error API', countKey: 'api_error'},
          {value: 'other', label: 'Otro', countKey: 'other'},
      ];

      return (
          <div className="mb-5 px-4">
              <span className="text-muted font-weight-bold mr-3">Filtrar motivo:</span>
              {filters.map((filter) => {
                  const isActive = this.state.attemptReasonFilter === filter.value;
                  const badgeClass = isActive ? 'badge-primary' : 'badge-light-primary';

                  return (
                      <button
                          key={filter.countKey}
                          type="button"
                          className={`badge border-0 mr-2 mb-2 ${badgeClass}`}
                          onClick={() => this.handleAttemptReasonFilter(filter.value)}
                      >
                          {filter.label}: {counts[filter.countKey] ?? 0}
                      </button>
                  );
              })}
          </div>
      );
  }

  renderAttemptsTable() {
  const formatCountryLabel = (countryId) => {
      const normalizedCountryId = Number(countryId);

      if (normalizedCountryId === 1) {
          return 'México';
      }

      if (normalizedCountryId === 2) {
          return 'Colombia';
      }

      if (normalizedCountryId === 3) {
          return 'Brasil';
      }

      return 'Otro';
  };

  return (
      <>
          {this.renderAttemptReasonFilters()}
          <table className="table table-borderless table-vertical-center mb-0">
                <tbody>
                {this.state.attempts.length === 0 &&
                    <tr>
                        <td className="text-center text-muted py-10">No hay intentos pendientes de sincronización.</td>
                    </tr>
                }
                {this.state.attempts.map((attempt) => {
                    const providerId = attempt.person_id;
                    const fiscalName = attempt.fiscal_name || 'Proveedor sin datos';
                    const rfc = attempt.rfc || 'Sin RFC';
                    const countryText = attempt.country_label || formatCountryLabel(attempt.country_id);
                    const dossierStatus = attempt.dossier_status_name
                        ? `${attempt.dossier_status_name} (${attempt.dossier_status_id || 'sin id'})`
                        : (attempt.dossier_status_id ? `Estatus ${attempt.dossier_status_id}` : 'Sin estatus');
                    const wasSynced = Boolean(attempt.venvers_synced_at);
                    const syncedTiming = attempt.eligible_at && attempt.time_from_eligible_to_sync_human
                        ? `Tiempo desde que pasó a ${attempt.eligible_status_name || 'Completo/Vigente'}: ${attempt.time_from_eligible_to_sync_human}`
                        : 'Tiempo desde Completo/Vigente: sin fecha registrada en bitácora de expediente';
                    const exppedifyReasons = this.getExppedifyReasons(attempt);

                    return (
                        <tr key={attempt.id}>
                            <td className="pl-0 py-5" style={{width: '1%'}}>
                                <div className="symbol symbol-40">
                                    <div className="symbol-label text-white font-weight-bolder bg-warning">
                                        {fiscalName.charAt(0).toUpperCase()}
                                    </div>
                                </div>
                            </td>
                            <td className="text-left">
                                <a href={this.props.internal == 1 ? `/providers/${providerId}/internal` : `/providers/${providerId}`}>
                                    <div className="text-dark-75 font-weight-bolder mb-1 font-size-lg">
                                        {fiscalName} <span className="text-muted font-weight-normal">RFC: {rfc}</span>
                                    </div>
                                    <span className="text-muted d-block">No. interno: {attempt.internal_id || 'Sin No. interno'}</span>
                                    <span className="text-muted d-block">País: {countryText}</span>
                                    <span className="text-muted d-block">Email owner: {attempt.owner_email || 'Sin correo de owner'}</span>
                                    <span className="text-muted d-block">Plantilla: {attempt.dossier_title || 'Sin plantilla'} | Estatus expediente: {dossierStatus}</span>
                                </a>
                            </td>
                            <td className="text-left" style={{minWidth: '360px', whiteSpace: 'normal'}}>
                                <span className={`badge ${wasSynced ? 'badge-success' : 'badge-warning'}`}>
                                    {wasSynced ? 'Se pasó a Venvers' : 'No sincronizado'}
                                </span>
                                <span className="text-muted d-block mt-2">Intento: {this.formatAttemptDate(attempt.attempted_at || attempt.created_at)}</span>
                                {wasSynced && <span className="text-success d-block mt-1">Se pasó a Venvers: {attempt.venvers_synced_at}</span>}
                                {wasSynced && <span className="text-muted d-block mt-1">Desde: {attempt.eligible_at || 'Sin fecha Completo/Vigente'} {attempt.eligible_status_name ? `(${attempt.eligible_status_name})` : ''}</span>}
                                {wasSynced && <span className="text-dark d-block mt-1">{syncedTiming}</span>}
                                {exppedifyReasons.length > 0 &&
                                    <div className="mt-3">
                                        <span className="text-dark font-weight-bolder d-block mb-1">Motivo:</span>
                                        <ul className="mb-0 pl-4 text-dark">
                                            {exppedifyReasons.map((reason, index) => (
                                                <li key={index}>{reason}</li>
                                            ))}
                                        </ul>
                                    </div>
                                }
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
            {this.state.attemptsTotal > this.state.maxRecords &&
                <SimplePagination
                updateCurrentPage={this.updateCurrentPage}
                currentPage={this.state.attemptsPage}
                totalFiles={this.state.attemptsTotal}
                split={this.state.maxRecords} />
            }
        </>
    );
  }

  render() {
    const { lang } = this.context;
    const exportQuery = new URLSearchParams();
    if (this.state.search !== '') {
        exportQuery.append('search', this.state.search);
    }
    if (this.state.syncFilter !== '') {
        exportQuery.append('sync_status', this.state.syncFilter);
    }
    const exportUrl = `/venvers_providers/export${exportQuery.toString() ? `?${exportQuery.toString()}` : ''}`;

    return (
    <>
        <div className="card card-custom gutter-b my-5">
            <div className="card-header border-0 pt-6">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder font-size-h4 text-dark-75">

                        Venvers
                    </span>

                    <span className="text-muted mt-3 font-weight-bold font-size-lg">
                        {this.state.activeTab === 'providers'
                            ? `${this.state.total} ${lang.get('messages.invitados_en_total')}`
                            : `${this.state.attemptsTotal} intentos pendientes (${this.state.attemptedProvidersTotal} proveedores)`}
                    </span>
                    <span className="mt-3 font-weight-bold font-size-sm d-block">
                        <button
                            type="button"
                            className={`badge mr-2 border-0 ${this.state.syncFilter === 'true' ? 'badge-success' : 'badge-light-success'}`}
                            onClick={() => this.handleSyncFilter(this.state.syncFilter === 'true' ? '' : 'true')}
                        >
                            Existe en Venvers: {this.state.syncStatusSummary.exists}
                        </button>
                        <button
                            type="button"
                            className={`badge mr-2 border-0 ${this.state.syncFilter === 'false' ? 'badge-secondary' : 'badge-light-secondary'}`}
                            onClick={() => this.handleSyncFilter(this.state.syncFilter === 'false' ? '' : 'false')}
                        >
                            No existe en Venvers: {this.state.syncStatusSummary.missing}
                        </button>
                        <button
                            type="button"
                            className={`badge border-0 ${this.state.activeTab === 'attempts' ? 'badge-warning' : 'badge-light-warning'}`}
                            onClick={() => this.handleTabChange('attempts')}
                        >
                            Proveedores no sincronizados: {this.state.attemptsTotal}
                        </button>
                    </span>
                </h3>
                <div className="card-toolbar">
                    <div className="d-flex align-items-center">
                        {this.state.activeTab === 'providers' &&
                            <a href={exportUrl} className="btn btn-light-primary font-weight-bolder mr-3">
                                <i className="flaticon2-download"></i>
                                Exportar Excel
                            </a>
                        }
                        <div className="input-icon">
                            <input
                                style={{width:'400px'}}
                                onChange={this.handleChange}
                                name="search"
                                type="text"
                                className="form-control"
                                placeholder={this.state.activeTab === 'attempts' ? 'Buscar por RFC' : lang.get('messages.buscar_invitado')} />
                            <span>
                                <i className="flaticon2-search-1 text-primary icon-md"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body pt-0">
                <ul className="nav nav-tabs nav-tabs-line mb-5 px-4">
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link border-0 font-size-sm px-4 ${this.state.activeTab === 'providers' ? 'active' : ''}`}
                            onClick={() => this.handleTabChange('providers')}
                        >
                            Proveedores Venvers
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link border-0 font-size-sm px-4 ${this.state.activeTab === 'attempts' ? 'active' : ''}`}
                            onClick={() => this.handleTabChange('attempts')}
                        >
                            Proveedores no sincronizados
                        </button>
                    </li>
                </ul>
                {this.state.activeTab === 'providers' ? this.renderProvidersTable(lang) : this.renderAttemptsTable()}
            </div>
        </div>
        </>
    );
    }
}

export default VenversProviders;
